export const CART = 'token-cart';
export const TOKEN_CONGDONG = 'token';
export const TOKEN_SHOP = 'token_shop';
export const TOKEN_CHAT = 'chat_token';